import { Component } from '@angular/core';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-page-stats-layout',
  imports: [KENDO_GRIDLAYOUT],
  templateUrl: './page-stats-layout.component.html',
  styleUrl: './page-stats-layout.component.scss',
})
export class PageStatsLayoutComponent {}
